export class StorageService {
  static setReferralAttached(userId: string): void {
    const key = `ref-attached-${userId}`
    localStorage.setItem(key, '1')
  }

  static isReferralAttached(userId: string): boolean {
    const key = `ref-attached-${userId}`
    return localStorage.getItem(key) === '1'
  }

  static setOnboardingCompleted(userId: string): void {
    const key = `onboarding-completed-${userId}`
    localStorage.setItem(key, '1')
  }

  static isOnboardingCompleted(userId: string): boolean {
    const key = `onboarding-completed-${userId}`
    return localStorage.getItem(key) === '1'
  }
}
